module.exports = __webpack_public_path__ + "img/analytics-marketing-team-6.2a757a78.svg";